export { PromotionModal } from './PromotionModal';
export type { PromotionModalProps } from './PromotionModal';
